
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/knowledge-hub",
      function () {
        return require("private-next-pages/agents/knowledge-hub.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/knowledge-hub"])
      });
    }
  